import React from 'react'
import Modal from './../../../components/modal/modal.component'
import Button from '../../../components/buttons/buttons.component'
import styled from 'styled-components'
import TripOption from './trip-option-container.component'
import NoTripsFound from './no-trips-found.component'
import BusSeatSelection from './bus-seat-selection/bus-seat-selection.component'
import { conexaoActions } from '../../../ducks/conexao/conexaoReducer'
import { Creators as ProgressBarCreators } from '../../../ducks/progress-bar/progress-bar'
import TicketSaleService from './../../../services/ticket-sale.service'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import BusSeatSelectionSelectors from '../../../selectors/bus-seat-selection.selectors'
import { isMobile } from './../../../services/breakpoints.service'
import { breakpoints } from '../../../constants'
import { connect } from 'react-redux'
import { GRAY, PRIMARY_LIGHT, WHITE } from '../../../styles/colors.style'
import { dateHelper } from '../../../helpers'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../actions'
import { bindActionCreators } from 'redux'
import { busSeatSelectionActions } from './../../../actions/bus-seat-selection.actions'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import Logomark from '../../../components/layout/logomark.component'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import Browser from '../../../services/Browser'
import { routes } from './../../../constants/routes.constants'
import { history } from './../../../helpers/history'
import { CalculationsService } from '../../../services'
import { ERROR_MSG_CALCULATED_VALUES } from '@constants'
import CalendarCarousel from '../../calendar-carousel'

class DestinationSelectStepComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isModalOpen: false,
		}

		this.openModal = openModal.bind(this)
		this.closeModal = closeModal.bind(this)
		this.onContinue = onContinue.bind(this)
		this.cleanSalesData = cleanSalesData.bind(this)
		this.redirectToPlans = redirectToPlans.bind(this)
		this.onOptionSelected = onOptionSelected.bind(this)
		this.deselectCurrentSeats = deselectCurrentSeats.bind(this)
	}

	render() {
		const {
			originTitle,
			destinationTitle,
			tripsReturn,
			previousStep,
			setIsUpgrade,
			busSeatsReturn,
			tripDateReturn,
			setOriginReturn,
			setDestinationReturn,
			totalSeatsReturn,
			backToPreviousStep,
			deselectBusSeatReturn,
			selectBusSeatReturn,
		} = this.props

		let dateReturn

		if (tripDateReturn instanceof Date) {
			dateReturn = tripDateReturn
		} else if (tripDateReturn) {
			dateReturn = new Date(tripDateReturn.replace(/-/g, '/'))
		} else {
			dateReturn = new Date()
		}

		return (
			<StyledContainer>
				<CalendarCarousel
					selectedDate={dateReturn}
					limitDate={this.props.tripDateGoing}
					isGoing={false}
					searchTrips={this.props.performSearchTrips}
					toastWarning={this.props.toastWarning}
					origin={destinationTitle}
					destination={originTitle}
				/>
				{tripsReturn.length ? (
					<React.Fragment>
						<StyledHeader>
							<div className="trip-date">
								<span className="bold">
									{dateHelper.getDayMonth(dateReturn)}
								</span>
								<br />
								<span className={'day-of-week'}>
									{dateHelper.getDayOfWeek(dateReturn)}
								</span>
							</div>
							<div className={'trip-origin-destination'}>
								<h2>
									Passagem de ônibus de {destinationTitle.label} para{' '}
									{originTitle.label}
								</h2>
							</div>
						</StyledHeader>
						{tripsReturn.map((tripReturn, index) => {
							let origin = tripReturn.ehConexao
								? tripReturn.conexao.trecho[0].origin
								: tripReturn.origem

							let destination = tripReturn.ehConexao
								? tripReturn.conexao.trecho[
									tripReturn.conexao.trecho.length - 1
								].destino
								: tripReturn.destino

							return (
								<TripOption
									key={index}
									price={tripReturn.price}
									origin={origin}
									arrival={tripReturn.arrival}
									busClass={tripReturn.busClass}
									duration={tripReturn.duration}
									forReturnTrip={true}
									promotion={tripReturn.promotion}
									departure={tripReturn.departure}
									freeSeats={tripReturn.freeSeats}
									upgradeTo={tripReturn.upgradeTo}
									busCompany={tripReturn.enterprise}
									canUpgrade={tripReturn.canUpgrade}
									destination={destination}
									tripDate={tripDateReturn}
									showFreeSeats={tripReturn.showFreeSeats}
									raceDate={tripReturn.raceDate}
									promotionPercent={tripReturn.promotionPercent}
									ehConexao={tripReturn.ehConexao}
									conexao={tripReturn.conexao}
									onSelect={(price, doUpgrade) => {
										setOriginReturn(tripReturn)
										setDestinationReturn(tripReturn)

										const params = {
											originId: tripReturn.origemId,
											destinationId: tripReturn.destinoId,
											tripDate: tripReturn.departure,
											service: tripReturn.service,
											group: tripReturn.group,
											classCode: tripReturn.classCode,
											ScheduleKey: tripReturn.scheduleKey,
											busCompany: tripReturn.enterprise,
											raceDate: tripReturn.raceDate,
											Provider: tripReturn.provider,
											conexao: tripReturn.conexao,
											ehConexao: tripReturn.ehConexao,
										}

										if (doUpgrade) {
											params.tripIndex = tripReturn.upgradeTo.index
											params.totalSeats = tripReturn.totalSeats
										}

										setIsUpgrade(!!doUpgrade)

										return this.onOptionSelected(params, price, index)
									}}
								/>
							)
						})}
						<Modal
							mobileFullWidth={true}
							onClose={this.cleanSalesData}
							isOpen={this.state.isModalOpen}>
							<BusSeatSelection
								busSeats={busSeatsReturn}
								onCancel={this.cleanSalesData}
								onContinue={this.onContinue}
								totalSeats={totalSeatsReturn}
								onDeselect={deselectBusSeatReturn}
								onSelect={selectBusSeatReturn}
							/>
						</Modal>
					</React.Fragment>
				) : (
					<NoTripsFound message="O melhor preço de passagens está aqui!" />
				)}
				<StyledButtonContainer>
					<Button
						secondary
						type="button"
						onClick={() => (backToPreviousStep(), previousStep())}>
						Voltar
					</Button>
				</StyledButtonContainer>
			</StyledContainer>
		)
	}
}

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 20px;
	margin-bottom: 60px;
`
async function onContinue() {
	const { ordemViagemVoltaConexao, loadBusSeatsReturnConexao, conexaoStore } =
		this.props

	if (
		conexaoStore.ehConexaoVolta &&
		conexaoStore.ordemViagemVolta < conexaoStore.quantidadeViagensVolta
	) {
		//chamar bus set
		ordemViagemVoltaConexao()

		try {
			await loadBusSeatsReturnConexao(
				conexaoStore.conexaoVolta.trecho[conexaoStore.ordemViagemVolta]
			)
		} catch (error) {
			this.props.toastWarning({
				message:
					'Erro ao buscar poltronas do próximo ônibus, tente novamente.',
			})
			this.props.setStepOrderCurrent(this.props.stepOrderCurrent - 1)
			return
		}

		this.openModal()
	} else {
		this.setState({ isModalOpen: false })
		this.props.setEtapaPagamento(true)
		this.props.hideLoading()
		this.props.nextStep()
	}
}

async function onOptionSelected(tripReturn, price, index) {
	const {
		setTotalSeatsReturn,
		setSelectedTripReturn,
		setSelectedPriceReturn,
		setGroupAndServiceReturn,
		viagemVoltaConexao,
		ordemViagemVoltaConexao,
		loadBusSeatsReturnConexao,
		showLoading,
		hideLoading,
	} = this.props

	setSelectedPriceReturn(price)
	setTotalSeatsReturn(tripReturn.totalSeats)
	setSelectedTripReturn(index)
	setGroupAndServiceReturn(tripReturn.group, tripReturn.service)

	showLoading()

	await this.deselectCurrentSeats()

	if (tripReturn.ehConexao) {
		viagemVoltaConexao(tripReturn.conexao)
		ordemViagemVoltaConexao()
		await loadBusSeatsReturnConexao(tripReturn.conexao.trecho[0])
	} else {
		const { loadBusSeatsReturn } = this.props
		await loadBusSeatsReturn(tripReturn)
	}

	hideLoading()
	this.openModal()
}

async function deselectCurrentSeats() {
	for (const busSeatReturn of this.props.selectedBusSeatsReturn) {
		var params = {
			...busSeatReturn,
			busSeat: busSeatReturn.number,
		}

		const { success } = await TicketSaleService.cancelBusSeatBooking(params)

		if (success) {
			this.props.deselectBusSeatReturn({ busSeat: busSeatReturn.number })
		}
	}
}

function openModal() {
	this.setState({ isModalOpen: true })
}

function redirectToPlans() {
	history.push(`${routes.CLIENTE}/planos`)
}

function closeModal() {
	this.setState({ isModalOpen: false })
}

async function cleanSalesData() {
	this.deselectCurrentSeats()
	this.closeModal()

	await this.props.setIsCalculatingValues(true)

	const values = this.props.calculatedValues

	try {
		const { success, data } = await CalculationsService.getCalculatedValues({
			...values,
			ticketsReturn: [],
		})

		if (success) {
			this.props.setCalculatedValues({
				...values,
				...data,
				totalInterest: values.totalInterest,
				ticketsGoing: values.ticketsGoing,
				ticketsReturn: [],
			})
		} else {
			throw new Error()
		}
	} catch (error) {
		this.props.toastError({ message: ERROR_MSG_CALCULATED_VALUES })
		this.props.resetTicketSale()
		this.props.setCurrent(0)
	} finally {
		this.props.setIsCalculatingValues(false)
	}
}

const StyledContainer = styled.div`
	margin-bottom: 15px;
`

const StyledHeader = styled.div`
	display: flex;
	margin-bottom: 10px;
	font-size: x-large;

	.trip-date {
		align-items: center;
		background: ${PRIMARY_LIGHT};
		border-top-left-radius: 5px;
		color: ${WHITE};
		flex-wrap: ${Browser.isInternetExplorer() ? 'wrap' : 'nowrap'};
		margin-right: 5px;
		padding: 10px 2px;
		text-align: center;
		width: 96px;
		scroll-behavior: smooth;

		.day-of-week {
			text-transform: capitalize;
			font-size: 1.5rem;
		}

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			display: initial;
		}
	}

	.trip-origin-destination {
		background: ${PRIMARY_LIGHT};
		border-top-right-radius: 5px;
		color: ${WHITE};
		flex-grow: 1;
		font-size: large;
		padding: 4px 6px;
		vertical-align: middle;
		font-weight: 600;

		height: auto;
		min-height: 45px;
		position: relative;

		h2 {
			position: absolute;
			top: 48%;
			transform: translateY(-48%);
			font-family: 'Source Sans Pro';
			font-weight: 600;
			font-size: 2.4rem;
			display: flex;
			flex-direction: row;
		}

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			font-size: inherit;
		}
	}
`

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			toastWarning: toastActions.warning,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			setIsUpgrade: TicketSaleCreators.setIsUpgradeReturn,
			backToPreviousStep: TicketSaleCreators.backToPreviousStep,
			loadBusSeatsReturn: busSeatSelectionActions.loadBusSeatsReturn,
			setSelectedTripReturn: TicketSaleCreators.setSelectedTripReturn,
			selectBusSeatReturn: busSeatSelectionActions.selectBusSeatReturn,
			setTotalSeatsReturn: busSeatSelectionActions.setTotalSeatsReturn,
			setSelectedPriceReturn: TicketSaleCreators.setSelectedPriceReturn,
			deselectBusSeatReturn: busSeatSelectionActions.deselectBusSeatReturn,
			setGroupAndServiceReturn: TicketSaleCreators.setGroupAndServiceReturn,
			viagemVoltaConexao: conexaoActions.setViagemVolta,
			ordemViagemVoltaConexao: conexaoActions.setOrdemViagemVolta,
			loadBusSeatsReturnConexao:
				busSeatSelectionActions.loadBusSeatsReturnConexao,
			setStepOrderCurrent: TicketSaleCreators.setStepOrderCurrent,
			setOriginReturn: TicketSaleCreators.updateOriginReturn,
			setDestinationReturn: TicketSaleCreators.updateDestinationReturn,
			setEtapaPagamento: TicketSaleCreators.setEtapaPagamento,
			setCalculatedValues: TicketSaleCreators.setCalculatedValues,
			setIsCalculatingValues: TicketSaleCreators.setIsCalculatingValues,
			toastError: toastActions.danger,
			resetTicketSale: TicketSaleCreators.reset,
			setCurrent: ProgressBarCreators.setCurrent,
			performSearchTrips: TicketSaleCreators.performSearchTrips,
		},
		dispatch
	)

const mapStateToProps = (store) => ({
	origin: store.ticketSale.origin,
	originState: store.ticketSale.originState,
	destination: store.ticketSale.destination,
	tripDateReturn: store.ticketSale.tripDateReturn,
	tripDateGoing: store.ticketSale.tripDateGoing,
	destinationState: store.ticketSale.destinationState,
	busSeatsReturn: store.busSeatSelection.busSeatsReturn,
	totalSeatsReturn: store.busSeatSelection.totalSeatsReturn,
	tripsReturn: TicketSaleSelectors.getTripsReturn(store),
	numberOfPassengers: BusSeatSelectionSelectors.getNumberOfPassengers(
		store.busSeatSelection
	),
	busSearchParametersReturn:
		TicketSaleSelectors.getBusSearchParametersReturn(store),
	selectedBusSeatsReturn: BusSeatSelectionSelectors.getSelectedBusSeatsReturn(
		store.busSeatSelection
	),
	conexaoStore: store.conexao,
	stepOrderCurrent: store.ticketSale.stepOrderCurrent,
	originTitle: store.ticketSale.originTitle,
	destinationTitle: store.ticketSale.destinationTitle,
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
})

const DestinationSelectStep = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(DestinationSelectStepComponent)
)

export default DestinationSelectStep
